import { getDefaultStore } from "jotai";

import { measureModeAtom } from "../../atoms/measureAtoms";
import { activeSegmentIndexAtom, isSegmentationActiveAtom } from "../../atoms/segmentationAtoms";
import { registerCommand } from "./registry";

// Entering measure mode fans out three writes atomically: the measure request
// itself, plus the segmentation flags that put the case viewer into the same
// render state as the labeling annotator (contour representation visible,
// segment 1 active). Cornerstone-side style override stays in a small useEffect
// in CaseViewer that legitimately syncs with the external tool's style API.
registerCommand("enterMeasureMode", ({ request }) => {
  const store = getDefaultStore();
  store.set(measureModeAtom, request);
  store.set(isSegmentationActiveAtom, true);
  store.set(activeSegmentIndexAtom, 1);
});
